<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>手机登录</span>
    </header>
    <main :class="[cellCacheState ? $style.hasCellCache : '']">
      <div :class="[$style.content, cellCacheState ? $style.pt : '']">
        <div :class="$style.accountWrap">
          <div :class="$style.inputWrap">
            <img :src="shoujiIcon" :class="$style.leftIcon" />
            <input type="number" placeholder="请输入手机号" v-model.trim="form.tel_num" />
            <img :src="xialaIcon" alt :class="$style.rightIcon" @click="showCellList" />
          </div>
          <transition name="slide">
            <ul :class="[$style.cellList, cellListVisible && $style.active]" ref="cellList">
              <div>
                <li v-for="(item, index) in cellList" :key="index" @click="selectAccount(item)">
                  <img :src="zhanghao1Icon" />
                  <span>{{ item.tel_num }}</span>
                </li>
              </div>
            </ul>
          </transition>
        </div>
        <div :class="[$style.inputWrap, $style.code]" v-if="!cellCacheState">
          <img :src="yanzhengmaIcon" :class="$style.leftIcon" />
          <input type="number" placeholder="请输入验证码" v-model.trim="form.smsCode" />
          <span :class="$style.getCode" @click="getVerifyCode" v-if="!count">获取</span>
          <span :class="$style.getCode" v-else>{{ count }}</span>
        </div>
      </div>
      <div :class="$style.agree">
        <img
          :class="[agreement ? $style.xuanzhong: '']"
          @click="tocheck"
          :src="agreement ? xuanzhongIcon : weixuanzhongIcon"
          alt
        />
        <span
          >我已阅读并接受<span @click="redirectArgument(0, 2)">《用户服务协议》</span>和<span @click="redirectArgument(1, 2)"
            >《用户隐私协议》</span
          ></span
        >
      </div>
      <button :class="$style.submitBtn" @click="toLogin"><span>登录</span></button>
      <div :class="$style.redirect">
        <span @click="toReg" v-if="!hideRegister">快速注册</span>
        <span v-if="hideRegister"></span>
        <span @click="toAccountLogin">账号登录</span>
        <span v-if="hideRegister"></span>
      </div>
    </main>
  </div>
</template>
<script>
import BScroll from "@better-scroll/core";
import { mapState } from 'vuex';
import { getCellLoginCode as getVerifyCodeApi } from '@/api/user';
import moment from 'moment';
import CountDown from '@/mixins/countDown';
import CryptoJS from 'crypto-js';
import { regexpVerify } from '@/libs/business/account';
import { Toast } from 'vant';
import isFullScreen from '@/libs/business/fullScreen';
import { getAccount, getCellAccount } from '@/libs/utils'
import _ from 'lodash';

export default {
  data() {
    return {
      fullScreen: '',
      form: {
        tel_num: '',
        smsCode: '',
        credential: ''
      },
      agreement: false, // 是否同意协议
      cellListVisible: false,
      cellList: [],
      shoujiIcon: `${this.$cdnLink}/wanXin/orangeTheme/shoujihao.png`,
      xialaIcon: `${this.$cdnLink}/wanXin/orangeTheme/xiala.png`,
      zhanghao1Icon: `${this.$cdnLink}/wanXin/orangeTheme/zhanghao1.png`,
      yanzhengmaIcon: `${this.$cdnLink}/wanXin/orangeTheme/yanzhengma.png`,
      xuanzhongIcon: `${this.$cdnLink}/wanXin/orangeTheme/xuanzhong.png`,
      weixuanzhongIcon: `${this.$cdnLink}/wanXin/orangeTheme/weixuanzhong.png`
    };
  },
  mixins: [CountDown],
  props: ["hideRegister"],
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    this.scrollInit();
    this.getCellList();
  },
  computed: {
    ...mapState({
      device_id: (state) => state.user.device_info.uuid,
      device_info: (state) => state.user.device_info,
      appkey: (state) => state.user.appkey,
      channel_status: state => state.user.channel_status
    }),
    cellCacheState() {
      const result = this.cellList.find(item => item.tel_num === this.form.tel_num);
      return result && result.credential
    }
  },
  watch: {
    channel_status(val) {
      const cache = localStorage.getItem('agreement_flag');
      if (val == 1) {
        this.agreement = false
      } else if (cache == '1') {
        this.agreement = true;
      }
    }
  },
  methods: {
    tocheck() {
      this.agreement = !this.agreement;
    },
    redirectArgument(type, source) {
      this.$emit('redirectArgument', type, source);
    },
    async getVerifyCode() {
      // 如果是注册情况，在获取验证码这个时机重新去安卓客户端获取一次oaid
      this.$store.dispatch('user/refreshOaid');
      const { tel_num } = this.form;
      const time = moment().unix();
      await regexpVerify(this.form, [{ key: 'tel_num', hint: '请输入正确的手机号', type: 'phone' }]);
      const sign = CryptoJS.MD5(CryptoJS.MD5(this.device_id + time + tel_num) + this.device_id + time + tel_num).toString();
      const r = await getVerifyCodeApi({
        tel_num,
        time,
        sign,
        device_id: this.device_id,
        jh_app_id: this.appkey,
        // box_client_ip: this.device_info.inip
      });
      this.type = r.content.type;
      localStorage.setItem('cellLoginCodeType', r.content.type);
      Toast('发送成功');
      this.setTimer();
    },
    selectAccount(item) {
      this.form = _.cloneDeep(item);
      this.cellListVisible = false;
    },
    async toLogin() {
      await regexpVerify(this.form, [
        { key: 'tel_num', hint: '请输入正确的手机号', type: 'phone' },
      ]);
      if (!this.cellCacheState) {
        await regexpVerify(this.form, [
          { key: 'smsCode', hint: '请输入正确的验证码' },
        ]);
        if (!localStorage.getItem('cellLoginCodeType')) {
          this.$toast('请获取正确的验证码');
          return;
        }
        this.$emit('login', {
          tel_num: this.form.tel_num,
          smsCode: this.form.smsCode,
          agreementState: this.agreement
        });
      } else {
        this.$emit('login', {
          tel_num: this.form.tel_num,
          credential: this.form.credential,
          agreementState: this.agreement
        });
      }
    },
    toReg() {
      this.$emit("redirectRegist");
    },
    toAccountLogin() {
      this.$emit("redirectAccountLogin");
    },
    showCellList() {
      this.cellListVisible = !this.cellListVisible;
      if (this.cellListVisible) {
        setTimeout(() => {
          this.bs && this.bs.refresh();
        }, 200);
      }
    },
    // type. 存在表示通过外部调用，不做赋值处理
    getCellList(type) {
      this.cellList = getCellAccount();
      if (this.cellList && this.cellList.length && !type) this.form = _.cloneDeep(this.cellList[0]);
    },
    scrollInit() {
      this.bs = new BScroll(this.$refs.cellList, {
        click: true,
        bounceTime: 300,
      });
    },
  },
};
</script>
<style lang="scss" module>
@import '../../../assets/css/common.scss';

.wrap {
  @include common-window(true);
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding-top: 0.28rem;
    .accountWrap {
      position: relative;
      .inputWrap {
        position: relative;
        z-index: 10;
      }
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.code {
        margin-top: 0.22rem;
        margin-bottom: 0.28rem;
        > input {
          width: 2.6rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: $primary-color;
          border-left: 1px solid $primary-color;
          padding-left: 0.2rem;
          height: 0.5rem;
          font-size: $font-nm-1;
        }
      }
    }
    .cellList {
      position: absolute;
      top: 0.3rem;
      width: 4.44rem;
      left: 0;
      right: 0;
      margin: auto;
      height: 0;
      background: #f3f3f3;
      border-radius: 0 0 0.4rem 0.4rem;
      transition: height 200ms ease-in;
      perspective: 1000px;
      overflow: auto;
      z-index: 5;
      &.active {
        height: 2rem;
      }
      li {
        display: flex;
        padding: 0.15rem 0;
        margin: 0 0.3rem;
        align-items: center;
        border-bottom: 1px solid #dad9d9;
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
          border-bottom: 0.5px solid #dad9d9;
        }
        @media screen and (-webkit-min-device-pixel-ratio: 3) {
          border-bottom: 0.333333px solid #dad9d9;
        }
        > img {
          width: 0.22rem;
        }
        > span {
          width: 3.5rem;
          padding-left: 0.1rem;
        }
      }
      li:nth-child(1) {
        padding-top: 0.65rem;
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      font-weight: 500;
      > span {
        // background: #000000;
        padding: 0.4rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.18rem;
      color: #999999;
      margin-top: 0.16rem;
      margin-bottom: 0.14rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
        margin-top: 0.02rem;
      }
    }
    &.hasCellCache {
      padding-top: .8rem;
      .agree {
        margin-top: 0.8rem;
        margin-bottom: 0.22rem;
      }
      .redirect {
        > span {
          padding: 0.26rem 0.22rem 0.22rem 0.29rem;
        }
      }
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding-top: 13px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.code {
          margin-top: 11px;
          margin-bottom: 13px;
          > input {
            width: 130px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: $primary-color;
            border-left: 1px solid $primary-color;
            padding-left: 10px;
            height: 25px;
            font-size: $font-nm;
          }
        }
      }
      .cellList {
        position: absolute;
        top: 15px;
        width: 222px;
        left: 0;
        right: 0;
        margin: auto;
        height: 0;
        background: #f3f3f3;
        border-radius: 0 0 20px 20px;
        transition: height 200ms ease-in;
        perspective: 1000px;
        overflow: auto;
        z-index: 5;
        &.active {
          height: 100px;
        }
        li {
          display: flex;
          padding: 7px 0;
          margin: 0 15px;
          align-items: center;
          border-bottom: 1px solid #dad9d9;
          @media screen and (-webkit-min-device-pixel-ratio: 2) {
            border-bottom: 0.5px solid #dad9d9;
          }
          @media screen and (-webkit-min-device-pixel-ratio: 3) {
            border-bottom: 0.333333px solid #dad9d9;
          }
          > img {
            width: 11px;
          }
          > span {
            width: 175px;
            padding-left: 5px;
          }
          .del {
            // background-color: #000000;
            width: 32px;
            padding: 0 5px 0 15px;
          }
        }
        li:nth-child(1) {
          padding-top: 32px;
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 20px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
        margin-bottom: 7px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }
      &.hasCellCache {
        padding-top: 40px;
        .agree {
          margin-top: 40px;
          margin-bottom: 11px;
        }
        .redirect {
          > span {
            padding: 13px 11px 11px 15px;
          }
        }
      }
    }
  }
}
</style>
